const sectionIconWithTextB1Css = `
[data-type='section-icon-with-text-b1'] .wrapper-container {
  color: var(--text-color, #000000);
}

[data-type='section-icon-with-text-b1'] .wrapper-container[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-icon-with-text-b1'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-icon-with-text-b1'] .title-content {
  margin-bottom: 40px;
}

[data-type='section-icon-with-text-b1'] .title-content h1,
[data-type='section-icon-with-text-b1'] .title-content h2,
[data-type='section-icon-with-text-b1'] .title-content h3,
[data-type='section-icon-with-text-b1'] .title-content h4 {
  font-size: 24px;
  margin: 0 0 16px 0 !important;
}

[data-type='section-icon-with-text-b1'] .title-content h1 p,
[data-type='section-icon-with-text-b1'] .title-content h2 p,
[data-type='section-icon-with-text-b1'] .title-content h3 p,
[data-type='section-icon-with-text-b1'] .title-content h4 p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-icon-with-text-b1'] .wrap-items {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

[data-type='section-icon-with-text-b1'] .wrap-items[data-align-items='center'] {
  justify-content: center;
}

[data-type='section-icon-with-text-b1'] .wrap-items[data-align-items='left'] {
  justify-content: flex-start;
}

[data-type='section-icon-with-text-b1'] .wrap-items[data-align-items='right'] {
  justify-content: flex-end;
}

[data-type='section-icon-with-text-b1'] .wrap-items .item-w-t {
  width: calc((100% - (16px * (var(--col-per-view, 3) - 1))) / var(--col-per-view, 3));
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
}

[data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-img {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

[data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-img img {
  display: block;
  width: var(--with-icon, '100%');
  height: auto;
}

[data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text h1,
[data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text h2,
[data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text h3,
[data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text h4 {
  font-size: 20px;
  margin: 0 0 10px 0 !important;
}

[data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

@container (max-width: 768px) {
  [data-type='section-icon-with-text-b1'] .wrapper-container[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-icon-with-text-b1'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-icon-with-text-b1'] .title-content h1,
  [data-type='section-icon-with-text-b1'] .title-content h2,
  [data-type='section-icon-with-text-b1'] .title-content h3,
  [data-type='section-icon-with-text-b1'] .title-content h4 {
    font-size: 20px;
    margin: 0 0 12px 0 !important;
  }

  [data-type='section-icon-with-text-b1'] .title-content h1 p,
  [data-type='section-icon-with-text-b1'] .title-content h2 p,
  [data-type='section-icon-with-text-b1'] .title-content h3 p,
  [data-type='section-icon-with-text-b1'] .title-content h4 p {
    font-size: 14px;
  }

  [data-type='section-icon-with-text-b1'] .wrap-items .item-w-t {
    width: calc(((100% - (16px * 2)) / 3));
  }

  [data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text h1,
  [data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text h2,
  [data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text h3,
  [data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text h4 {
    font-size: 18px;
  }

  [data-type='section-icon-with-text-b1'] .wrap-items .item-w-t .wrap-text p {
    font-size: 14px;
  }
}

@container (max-width: 540px) {
  [data-type='section-icon-with-text-b1'] .wrap-items .item-w-t {
    width: calc(((100% - (16px * 1)) / 2));
  }
}
`;
export default sectionIconWithTextB1Css;
